export default __webpack_public_path__ + "static/marketuppercard-8d520def848e7fe5e94d6e5c70bc0976.png";